<template>
  <div class="postDetail">
    <img class="bg" :src="images.bg" />
    <div class="postContainer">
      <div class="mainView">
        <div class="header">
          <img class="back" :src="images.back" @click="goBack()" />
        </div>
        <div class="contentView" v-if="current_post">
          <PostItem :dic="current_post" :owner-info="ownerInfo" :show-comment="true" from="PostDetail"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BG,
  IMG_BACK
} from "../assets";

// @ is an alias to /src
import PostItem from "./components/PostItem.vue";

import { types as LoginTypes } from "@/store/modules/login";
import { types as CommunityTypes } from "@/store/modules/community";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "PostDetail",
  components: {
    PostItem
  },
  data() {
    return {
      images:{
        bg: BG,
        back: IMG_BACK
      },
      page:1,
      load_more: false
    };
  },
  computed: {
    ...mapState({
      ownerInfo: state => state.login.userInfo,
      current_post: state => state.community.current_post,
      comment_data: state => state.community.comment_data
    }),
  },
  watch: {
    current_post (value){
      if(value && value.pk){
        this.fetchCommentList({pk: value.pk, page:1})
      }
    },
    comment_data (value){
      let response = value
      if (response.next) {
        this.load_more = true;
      } else {
        this.load_more = false;
      }
    }
  },

  methods: {
    ...mapActions({
      fetchOwnInfo: LoginTypes.FETCH_USERINFO,
      fetchPostDetail: CommunityTypes.FETCH_POST_DETAIL,
      fetchCommentList: CommunityTypes.FETCH_COMMENT_LIST,
      fetchCreateEvent: CommunityTypes.FETCH_CREATE_EVENT,
      fetchLikeEvent: CommunityTypes.FETCH_LIKE_EVENT,
      fetchDeleteEvent: CommunityTypes.FETCH_DELETE_EVENT,
      fetchStickyEvent: CommunityTypes.FETCH_STICKY_EVENT,
      fetchEssenceEvent: CommunityTypes.FETCH_ESSENCE_EVENT,
      fetchHomeVideoEvent: CommunityTypes.FETCH_HOME_VIDEO_EVENT,
      fetchFlowerEvent: CommunityTypes.FETCH_FLOWER_EVENT,
      fetchForwardEvent: CommunityTypes.FETCH_FORWARD_EVENT,
      fetchFollowEvent: CommunityTypes.FETCH_FOLLOWERS_EVENT
    }),

    // 返回事件
    goBack(){
      if (window.history.length > 1) {
        this.$router.go(-1);
      }else if(window.history.length === 1){
        if (location.origin.includes("coding61.com")) {
          location.href = "https://www.coding61.com/index/CogaSelect";
        } else {
          location.href = "https://app.bcjiaoyu.com/index/CogaSelect";
        }
      }
    },
    load_more_comments(){
      if(this.load_more){
        this.page += 1
        this.fetchCommentList({pk: this.current_post.pk, page:this.page})
        this.load_more = false
      }
    },
    //-------------postItem 组件的回调函数
    // 发帖子，对帖子评论，对评论回复
    publish(type, data) {
      data["type"] = type;
      // console.log(data);
      this.fetchCreateEvent(data);
    },
    // 点赞
    likeEvent(type, data) {
      data["type"] = type;
      this.fetchLikeEvent(data);
    },
    // 删除帖子、评论、回复
    deleteEvent(type, data) {
      data["type"] = type;
      this.fetchDeleteEvent(data);
    },
    // 置顶帖子和取消
    stickyPost(type, data){
      data["type"] = type;
      this.fetchStickyEvent(data);
    },
    // 精华帖子和取消
    essencePost(type, data){
      data["type"] = type;
      this.fetchEssenceEvent(data);
    },
    // 上首页帖子和取消
    homePost(type, data){
      data["type"] = type;
      this.fetchHomeVideoEvent(data);
    },
    // 帖子送花
    flowerEvent(type, data) {
      data["type"] = type;
      this.fetchFlowerEvent(data);
    },
    // 帖子转发到朋友圈
    forwardEvent(type, data) {
      data["type"] = type;
      this.fetchForwardEvent(data);
    },
    // 关注/取关事件
    followEvent(type, data) {
      data["type"] = type;
      this.fetchFollowEvent(data);
    },
    // 加载更多评论事件
    loadMoreComment(post_id){
      this.load_more_comments();
    }
  },
  created() {},
  destroyed() {},
  mounted() {
    // console.log(this.$route, this.$router)
    this.fetchOwnInfo();
    let post_id = this.$route.params.post_id;
    this.fetchPostDetail({ pk: post_id });
  }
};
</script>

<style lang="less" scoped>
.postDetail {
  background-color: #6b45e1;
  width: 100%;
  /* height: 100%; */
  min-width: 1100px;
  min-height: 100%;

  background-size: 100%;
  position: relative;
}
.bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
.postContainer {
  width: 1000px;
  /* min-height: 100%;
  min-height: 680px; */
  /* height: 100%; */
  margin: 0 auto;
  // padding-top: 30px;
  padding-bottom: 30px;
  /* background-color: red; */

  /* display: flex;
  flex-direction: column; */
  z-index: 200;
  position: relative;
}
.mainView {
  .header {
    color: #ff6600;
    font-size: 40px;
    /* text-align: center; */
    height: 44px;
    line-height: 44px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: 30px;
    padding-bottom: 30px;
    .back {
      height: 44px;
      cursor: pointer;
    }
    .title {
      height: 44px;
    }
  }
  .contentView {
    width: 100%;
    padding-top: 30px;
    background-color: white;
    border-radius: 5px;
  }
}
</style>
